import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type GetShipmentFactoryDependencies = {
  repository: ShipmentRepository
}

export function getShipmentAsLoggedInUserFactory({ repository }: GetShipmentFactoryDependencies) {
  return function getShipmentByUUID(uuid: string, config?: { signal?: AbortSignal }) {
    return repository.getShipmentAsLoggedInUserByUUID(uuid, config)
  }
}

export function getShipmentAsLoggedInUser(id: string, config?: { signal?: AbortSignal }) {
  const httpClient = new HttpClient(API_URL)

  const repository = new ShipmentRepository({ httpClient })
  const get = getShipmentAsLoggedInUserFactory({ repository })

  return get(id, config)
}
